import { useEffect } from 'react';
import i18n, { LANG_KEY } from "../helpers/i18n";

const ALLOWED_LANGS = ['en', 'ru'];

export const useSyncLangFromUrl = () => {
    useEffect(() => {
        const url = new URL(window.location.href);

        const langFromUrl = url.searchParams.get('lang');
        const savedLang = localStorage.getItem(LANG_KEY);

        const isValidLang = (lang) => ALLOWED_LANGS.includes(lang);

        const applyLang = async (lang) => {
            if (!lang || !isValidLang(lang)) return;

            if (i18n.language !== lang) {
                await i18n.changeLanguage(lang);
            }

            localStorage.setItem(LANG_KEY, lang);
        };

        const run = async () => {
            if (langFromUrl && isValidLang(langFromUrl)) {
                await applyLang(langFromUrl);

                url.searchParams.delete('lang');
                const cleanUrl = `${url.pathname}${url.search}${url.hash}`;
                window.history.replaceState({}, '', cleanUrl);
                return;
            }

            if (savedLang && isValidLang(savedLang)) {
                await applyLang(savedLang);
            }
        };

        run();
    }, []);
};